import { render } from "./insure-team.vue?vue&type=template&id=6505cb64&scoped=true&ts=true"
import script from "./insure-team.vue?vue&type=script&lang=ts"
export * from "./insure-team.vue?vue&type=script&lang=ts"

import "./insure-team.vue?vue&type=style&index=0&id=6505cb64&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6505cb64"]])

export default __exports__